import React, { FunctionComponent } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import TextFormField from './TextFormField';
import { FormField } from '../../../store/modules/application/types';
import RepeatableFormField from './RepeatableFormField';
import SpacerFormField from './SpacerFormField';
import DatePicker from './DatePickerFormField';
import DropDownFormField from './DropDownFormField';
import TimePickerField from './TimePickerFormField';
import MultiSelectField from './MultiSelectDropdownFormField';
import { ErrorState } from '../types';

export type FormFieldProps = {
    formField: FormField;
    value: any;
    error?: ErrorState;
    readOnly?: boolean;
    handleInputChange: Function;
    formData?: Record<string, unknown>;
    isCustomStyle?: false | true;
    handleSelectedInspector?: Function;
};

const useStyles = makeStyles(() => ({
    detailNode: {
        paddingLeft: 20,
    },
    detailNodeMain: {
        width: '100%',
    },
    width: {
        width: '100%',
    },
}));

const FormFieldDisplay: FunctionComponent<FormFieldProps> = (props) => {
    const {
        value,
        error,
        readOnly,
        formData,
        formField,
        isCustomStyle,
        handleInputChange,
        handleSelectedInspector,
    } = props;

    const classes = useStyles();
    const detailNodeStyle = classNames({
        [classes.detailNode]: !isCustomStyle,
        [classes.width]: isCustomStyle,
    });

    let FieldComponent: FunctionComponent<FormFieldProps>;

    switch (formField.typeId) {
        case 'multiple':
            FieldComponent = RepeatableFormField;
            break;

        case 'spacer':
            FieldComponent = SpacerFormField;
            break;

        case 'date':
            FieldComponent = DatePicker;
            break;

        case 'choices': {
            if (formField.multiSelect) {
                FieldComponent = MultiSelectField;
            } else {
                FieldComponent = DropDownFormField;
            }

            break;
        }
        case 'time':
            FieldComponent = TimePickerField;
            break;

        default:
            FieldComponent = TextFormField;
            break;
    }

    if (formField.typeId !== 'system') {
        return (
            <Box className={detailNodeStyle}>
                <Box component="div" className={classes.detailNodeMain}>
                    <FieldComponent
                        formField={formField}
                        value={value}
                        error={error}
                        readOnly={readOnly}
                        handleInputChange={handleInputChange}
                        formData={formData}
                        isCustomStyle={isCustomStyle}
                        handleSelectedInspector={handleSelectedInspector}
                    />
                </Box>
            </Box>
        );
    } else {
        return null;
    }
};
export default FormFieldDisplay;
